import { render } from "./ApiTestPage.vue?vue&type=template&id=5a84a41f&scoped=true"
import script from "./ApiTestPage.vue?vue&type=script&lang=js"
export * from "./ApiTestPage.vue?vue&type=script&lang=js"

import "./ApiTestPage.vue?vue&type=style&index=0&id=5a84a41f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a84a41f"]])

export default __exports__